import { useCallback, useRef } from "react";

import StopAddressTypeForm from "./StopAddressTypeForm";
import StopPortForm from "./StopPortForm";
import StopPortCountry from "./StopPortCountry";
import StopAddressForm from "./StopAddressForm";
import FormItemInfo from "../../../Common/FormItemInfo";

interface StopAddressFormSectionProps {
  index: number;
}

export default function StopAddressFormSection({ index }: StopAddressFormSectionProps) {
  const portLinkedTimezoneRef = useRef<string | null>(null);
  const registerStopPortLinkedTimezone = useCallback((timezone: string | null) => {
    portLinkedTimezoneRef.current = timezone;
  }, []);

  return (
    <div className="d-flex mt-3xl mb-3xl">
      <div className="mr-xl" style={{ minWidth: "200px", flexShrink: 0 }}>
        <FormItemInfo labelId="general.address" label="Address" />
      </div>
      <div className="w-100">
        <StopAddressTypeForm index={index} />
        <StopPortForm index={index} registerStopPortLinkedTimezone={registerStopPortLinkedTimezone} />
        <StopPortCountry index={index} />
        <StopAddressForm index={index} portLinkedTimezoneRef={portLinkedTimezoneRef} />
      </div>
    </div>
  );
}
